/* global */

export const getTemplateDefs = (cols) => {
  let defs = "";
  cols.forEach((col) => {
    if (col === "*" || col === null) {
      defs += "1fr ";
    } else if (col[0] === "s") {
      defs += col.slice(1) + "px ";
      //defs += "24px ";
    } else {
      defs += col.toString() + "fr ";
    }
  });
  return defs.slice(0, defs.length - 1);
};

export const getWeights = (cols) => {
  return cols.map(getWeight);
};

export const getWeight = (c) => {
  if (c === "*" || c === null) {
    return 1.0;
  } else if (c[0] === "s") {
    return parseInt(c.slice(1));
  } else {
    return c;
  }
};

export const getPinsForMoving = (cols, width) => {
  let spacerSum = 0;
  cols
    .filter((c) => c[0] === "s")
    .forEach((c) => {
      spacerSum += parseInt(c.slice(1));
    });

  const weights = getWeights(cols);
  const sumWeights = weights.reduce((sum, a, i) => (cols[i][0] !== "s" ? sum + a : sum), 0);
  const unit = (width - 56 - spacerSum) / sumWeights;

  const pins = cols.map((r, i) => (r[0] === "s" ? weights[i] : weights[i] * unit));
  const pinsRolled = [
    0,
    ...pins.map((_, i) => {
      let p = 0;
      for (let j = 0; j < i + 1; j++) {
        p += pins[j];
      }
      return p;
    }),
  ];
  return pinsRolled;
};

export const findSmallestDistance = (arr, x) => {
  const dists = arr.map((p) => Math.abs(p - x));
  const smallest = Math.min(...dists);
  const found = dists.indexOf(smallest);
  return found;
};

export const findIndex = (arr, x, diff) => {
  for (let index = 0; index < arr.length; index++) {
    const e = arr[index];
    if (e - (diff ?? 0) > x) return index - 1;
  }
  return arr.length - 2;
};

export const nonSpacerCoords = (structure) => {
  const coords = [];
  let x = 0;
  let y = 0;

  for (let i = 0; i < structure.rows.length; i++) {
    const row = structure.rows[i];
    const isRowSpacer = row[0] === "s";
    y = 0;
    if (!isRowSpacer) {
      const rowCoords = [];
      for (let j = 0; j < structure.columns.length; j++) {
        const col = structure.columns[j];
        const isColSpacer = col[0] === "s";
        if (!isColSpacer) {
          rowCoords.push({ x, y });
        }
        y += 1;
      }
      coords.push(rowCoords);
    }
    x += 1;
  }
  return coords;
};

export const spacerDistribution = (structure) => {
  let vertical = -1;
  let vs = null;
  let vc = 0;
  let lastIsSpacerV = false;
  let horizontal = -1;
  let hs = null;
  let hc = 0;
  let lastIsSpacerH = false;

  for (let i = structure.rows.length - 1; i >= 0; i--) {
    const row = structure.rows[i];
    const isSpacer = row[0] === "s";
    if (isSpacer) {
      vs = i;
      if (vc === 0) {
        lastIsSpacerV = true;
      } else {
        vertical = vc;
        break;
      }
    } else {
      vc++;
    }
  }

  for (let i = structure.columns.length - 1; i >= 0; i--) {
    const col = structure.columns[i];
    const isSpacer = col[0] === "s";
    if (isSpacer) {
      hs = i;
      if (hc === 0) {
        lastIsSpacerH = true;
      } else {
        horizontal = hc;
        break;
      }
    } else {
      hc++;
    }
  }

  return { vertical, horizontal, row: vs, col: hs, lastIsSpacerH, lastIsSpacerV };
};

export const fromFileToReduxStructure = (gridd) => {
  return {
    structure: {
      columns: gridd.cols,
      rows: gridd.rows,
      cells: gridd.cells,
      merged: gridd.merged ?? [],
    },
    borders: gridd.borders ?? [],
    cellStyles: gridd.cellStyles ?? {},
    spacerStyles: gridd.spacerStyles ?? { columnColors: [], rowColors: [] },
  };
};
